import React from 'react';

const ProtocolStep = ({ number, title, desc }) => (
  <div className="relative group">
    <div className="text-[120px] font-black text-white/[0.03] absolute -top-20 -left-4 select-none group-hover:text-yellow-400/[0.05] transition-colors leading-none">
      {number}
    </div>
    <div className="relative z-10">
      <h4 className="text-2xl font-black uppercase tracking-tighter mb-4 flex items-center">
        <span className="w-8 h-px bg-yellow-400 mr-4"></span>
        {title}
      </h4>
      <p className="text-zinc-500 font-medium leading-relaxed">
        {desc}
      </p>
    </div>
  </div>
);

export default ProtocolStep;